var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHochbeetIconDis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_355",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_12",
    x: 4.601,
    y: 4.6,
    width: 32.799,
    height: 32.799,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RAISED_BED",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_355)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_355-2",
    "data-name": "Pfad 355",
    fill: "#f5f5f5",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_12)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_12-2",
    "data-name": "Vereinigungsmenge 12",
    className: "cls-1",
    d: "M27 24.152H9v-7H7v9h22v-9h-2zM11 20.259H25V22.259H11ZM13.542 11.36a8.524 8.524 0 0 0 3.437 2.021v3.67h2v-4.7a8.593 8.593 0 0 0 3.57-2.064 8.771 8.771 0 0 0 2.2-4.129l.138-.724-.724.14a8.737 8.737 0 0 0-4.115 2.2 8.782 8.782 0 0 0-2.166 3.994 8.326 8.326 0 0 0-1.831-2.926 8.732 8.732 0 0 0-4.114-2.2l-.724-.139.138.724a8.784 8.784 0 0 0 2.195 4.129m7.211-2.871A7.488 7.488 0 0 1 23.526 6.8a7.509 7.509 0 0 1-1.686 2.785 7.481 7.481 0 0 1-2.77 1.688 7.536 7.536 0 0 1 1.683-2.784m-5.415 1.068a7.436 7.436 0 0 1 1.641 2.676v.092a7.466 7.466 0 0 1-2.728-1.671 7.544 7.544 0 0 1-1.683-2.785 7.5 7.5 0 0 1 2.77 1.688M 14.972 17.052 h 2 v 2 H 14.972 zM 10.972 17.052 h 2 v 2 H 10.972 zM 23.028 17.052 h 2 v 2 H 23.028 zM21.028 19.052v-2h-2.055v2h2.055z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHochbeetIconDis);
export default __webpack_public_path__ + "static/media/hochbeet-icon-dis.e726623adeab546a433b0484984c94fa.svg";
export { ForwardRef as ReactComponent };